import Vue from "vue";
import router from "../../../router";
import { Notify } from "quasar";
import { analyticsController } from "../../user/analytics/AnalyticsController";
import { TinyEmitter } from "tiny-emitter";
import { userService } from "../../user/UserService";
import { userEventController } from "../../user/UserEventController";
import { isInMobileApp } from 'src/utils/MobileUtils';

export type OnboardingChecklistType = 'basic_info' | 'objectives' | 'equipment' | 'initial_evaluation' | 'hand_size' | 'training_program' | 'email_validation' | 'singing' | 'tokatab_exercises' | 'first_module' | 'first_song' | 'plug_piano';

class OnboardingChecklistController extends TinyEmitter {
  public state = Vue.observable({
    checklist: [
      {
        id: 'basic_info',
        label: '👀 Décrivez moi votre niveau en piano',
        completed: true,
        priority: 10,
        freeDays: 0,
        action: () => {
          this.emit('open__profileConfigurator')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'basic_info'
          })
        }
      },
      {
        id: 'objectives',
        label: '🎯 Définissez vos objectifs',
        completed: true,
        priority: 10,
        freeDays: 0,
        action: () => {
          this.emit('open__objectivesConfigurator')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'objectives'
          })
        }
      },
      {
        id: 'equipment',
        label: "🎹 Quel piano utilisez-vous ?",
        completed: false,
        priority: 1,
        freeDays: 0,
        action: () => {
          this.emit('open__equipmentConfigurator')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'equipment'
          })
        }
      },
      {
        id: 'hand_size',
        label: "🤲 Calculons la taille de vos mains",
        completed: false,
        priority: 3,
        freeDays: 0,
        action: () => {
          this.emit('open__handSizeConfigurator')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'hand_size'
          })
        }
      },
      {
        id: 'training_program',
        label: '🗓 Établissons votre planning',
        completed: false,
        priority: 4,
        freeDays: 0,
        action: () => {
          this.emit('open__sessionPicker')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'training_program'
          })
        }
      },
      {
        id: 'email_validation',
        label: '💌 Validez votre email',
        completed: false,
        priority: 6,
        freeDays: 0,
        action: () => {
          this.emit('open__emailValidation')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'email_validation'
          })
        }
      },
      {
        id: 'singing',
        label: "🎤  Déterminons votre tessiture vocale",
        completed: false,
        priority: 5,
        freeDays: 0,
        action: () => {
          this.emit('open__singingConfigurator')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'singing'
          })
        }
      },
      {
        id: 'import_my_piece',
        label: '📥 Importez un morceau de votre bibliothèque',
        completed: false,
        priority: 2,
        freeDays: 0,
        action: () => {
          router.push('/catalog/import').then()
          Notify.create({
            message: 'Importez un morceau depuis votre bibliothèque musicale pour compléter cet objectif !',
            classes: 'teacher__notification',
            progress: true,
            timeout: 6000,
          })
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'import_my_piece'
          })
        }
      }
      // {
      //   id: 'first_song',
      //   label: '🎼 Apprenez un nouveau morceau',
      //   completed: false,
      //   priority: 9,
      //   freeDays: 0,
      //   action: () => {
      //     router.push('/catalog').then()
      //     Notify.create({
      //       message: 'Voici la liste des morceaux, choisissez en un et terminez l\'apprentissage d\'une partie en utilisant le mode guidé pour compléter cet objectif !',
      //       classes: 'teacher__notification',
      //       progress: true,
      //       timeout: 6000,
      //     })
      //     analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
      //       item: 'first_song'
      //     })
      //   }
      // }
    ],
    localHidden: false,
    isLoaded: false
  });

  constructor() {
    super();
    userService.on('userService_loaded', () => {
      this.updateChecklistContent();
      this.state.isLoaded = true
    });
    userService.on('userService_levelUpdated', () => {
      this.updateChecklist()
      this.updateChecklistContent()
    })

    // setTimeout(() => {
    //   if (userService.user.configurations.keyboardType === 'midi' && !userService.user.configurations.onboardingConfig.checklistTasksCompleted.includes('plug_piano')) {
    //     this.addPlugPianoMission()
    //   }
    //   this.updateChecklist();
    // }, 1000);
  }

  private updateChecklist() {
    if (userService.user.level.value > 1 && !this.state.checklist.find(item => item.id === 'initial_evaluation')) {
      this.state.checklist.push(
        {
          id: 'initial_evaluation',
          label: '🥇 Passons votre test de niveau en piano',
          completed: false,
          priority: 2,
          freeDays: 0,
          action: () => {
            router.push('/player/evaluation').then()
            analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
              item: 'initial_evaluation'
            })
          }
        }
      )

      this.state.checklist.push({
        id: 'tokatab_exercises',
        label: '📘 Validez un premier exercice',
        completed: false,
        priority: 7,
        freeDays: 0,
        action: () => {
          router.push('/school/modules').then()
          Notify.create({
            message: 'Voici la liste des modules, choisissez en un et complétez au moins un exercice pour terminer cet objectif.',
            classes: 'teacher__notification',
            progress: true,
            timeout: 6000,
          })
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'tokatab_exercises'
          })
        }
      })
      this.state.checklist.push({
        id: 'first_module',
        label: '🎓 Terminez votre premier module',
        completed: false,
        priority: 8,
        freeDays: 0,
        action: () => {
          router.push('/school/modules').then()
          Notify.create({
            message: 'Voici la liste des modules, choisissez en un terminez le pour compléter cet objectif.',
            classes: 'teacher__notification',
            progress: true,
            timeout: 6000,
          })
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'first_module'
          })
        }
      })
    }
    else if (userService.user.level.value === 1 && this.state.checklist.find(item => item.id === 'initial_evaluation')) {
      this.state.checklist = this.state.checklist.filter(item => item.id !== 'initial_evaluation');
      this.state.checklist = this.state.checklist.filter(item => item.id !== 'tokatab_exercises');
      this.state.checklist = this.state.checklist.filter(item => item.id !== 'first_module');
    }
  }

  updateChecklistContent() {
    this.state.checklist.forEach(item => {
      if (this.userOnboardingConfig.checklistTasksCompleted.find(id => id === item.id) || (userService.user.configurations.onboardingConfig.hasFinishedInitialEvaluation && item.id === 'initial_evaluation')) {
        item.completed = true
      }
    });
  }

  public get orderedChecklist() {
    return this.state.checklist.sort((a, b) => a.priority - b.priority).sort((a, b) => !a.completed && b.completed ? -1 : 1)
  }

  public get totalFreeDays() {
    return this.state.checklist.reduce((acc, item) => acc + item.freeDays, 0)
  }
  public get totalFreeDaysUnlocked() {
    return this.state.checklist.filter(item => item.completed).reduce((acc, item) => acc + item.freeDays, 0)
  }

  public get totalSteps() {
    return this.state.checklist.length
  }
  public get totalStepCompleted() {
    return this.state.checklist.filter(item => item.completed).length
  }

  public get isUserEligibleToFreeDays() {
    return false;
  }
  private get userOnboardingConfig() {
    return userService.user.configurations.onboardingConfig
  }
  public get isHidden() {
    return this.state.localHidden || this.userOnboardingConfig.hideChecklist;
  }

  public completeTask(id: OnboardingChecklistType, silent: boolean = false) {
    const task = this.state.checklist.find(item => item.id === id)
    if(!task) {
      return;
    }

    if (!task.completed) {
      analyticsController.logBasicAnalyticsEvent('complete onboarding task', 'Onboarding Checklist', {
        task: id,
      })
      task.completed = true
      userEventController.newActivity('COMPLETE_CHECKLIST_STEP', null, null, { step: id })
      if (!silent && !this.isHidden) {

        if (this.totalStepCompleted === this.totalSteps) {
          userEventController.newActivity('COMPLETE_CHECKLIST', null, null, {})
          Notify.create({
            classes: 'teacher__notification',
            message: 'Bravo vous avez complété la checklist, vous êtes maintenant prêt pour profiter de toutes les fonctionnalitées de Tokatab !',
            color: 'positive',
            position: isInMobileApp() ? 'top' : 'bottom',
            timeout: 5000,
          })
        }
        else {
          Notify.create({
            classes: 'teacher__notification',
            message: 'Bravo vous avez terminé une des missions de la découverte de Tokatab !' + (task.freeDays && this.isUserEligibleToFreeDays ? ' Vous avez gagné ' + task.freeDays + ' jour(s) d\'essai gratuit supplémentaires !' : ''),
            color: 'positive',
            multiLine: true,
            position: isInMobileApp() ? 'top' : 'bottom',
            timeout: 5000,
          })
          this.fireAnimation().then();
        }
      }

      this.updateUserOnboardingConfig(id, this.totalStepCompleted === this.totalSteps, task.freeDays)
    }
  }

  async fireAnimation() {
    const end = Date.now() + 1000;
    (function frame() {
      // @ts-ignore
      window.confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        shapes: ["star"],
        colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
      });

      // @ts-ignore
      window.confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        shapes: ["star"],
        colors: ["FFE400", "FFBD00", "E89400", "FFCA6C", "FDFFB8"],
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  hideChecklist() {
    analyticsController.logBasicAnalyticsEvent('hide onboarding checklist', 'Onboarding checklist')
    this.updateUserOnboardingConfig(null, true)
  }
  private updateUserOnboardingConfig(taskCompleted: OnboardingChecklistType | null, hide: boolean = false, freeDays: number = 0) {
    const userOnboardingConfigCopy = JSON.parse(JSON.stringify(this.userOnboardingConfig));

    if (taskCompleted && this.userOnboardingConfig.checklistTasksCompleted.indexOf(taskCompleted) === -1) {
      userOnboardingConfigCopy.checklistTasksCompleted.push(taskCompleted);
    }
    if (hide) {
      userOnboardingConfigCopy.hideChecklist = true;
    }
    userService.updateConfiguration('ONBOARDING', userOnboardingConfigCopy).then();
  }

  addPlugPianoMission() {
    if (!this.state.checklist.find(item => item.id === 'plug_piano')) {
      this.state.checklist.unshift({
        id: 'plug_piano',
        label: '🔌 Branchez votre piano !',
        completed: false,
        priority: 1,
        freeDays: 2,
        action: () => {
          this.emit('open__plugPianoSlide')
          analyticsController.logBasicAnalyticsEvent('clicked on onboarding checklist item', 'Onboarding checklist', {
            item: 'plug_piano'
          })
        }
      })
    }
  }

  getIncompleteMissions() {
    return this.state.checklist.filter(item => item.completed === false);
  }
}

export const onboardingChecklistController = new OnboardingChecklistController();
